var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 258,
    height: 312.691,
    viewBox: "0 0 258 312.691",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(-107 -79)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M365,208.273c0,84.622-91.376,159.07-120.319,180.528a14.484,14.484,0,0,1-17.362,0C198.376,367.343,107,292.895,107,208.273a129,129,0,1,1,258,0Z",
    fill: "#5fb455"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M174.15,221.906a2.46,2.46,0,0,1,2.468-2.453H295.382a2.46,2.46,0,0,1,2.467,2.453v8.975a2.461,2.461,0,0,1-2.467,2.454H176.618a2.461,2.461,0,0,1-2.468-2.454Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M186.487,224.6a4.921,4.921,0,0,1,4.935-4.907h89.156a4.921,4.921,0,0,1,4.935,4.907v43.087a4.921,4.921,0,0,1-4.935,4.907H191.422a4.921,4.921,0,0,1-4.935-4.907Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M182.732,148.317a7.392,7.392,0,0,1,7.225-5.764h92.085a7.394,7.394,0,0,1,7.226,5.764l6.579,27.886a7.37,7.37,0,0,1-7.225,8.957H183.378a7.371,7.371,0,0,1-7.226-8.957Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M193.889,181.81a2.46,2.46,0,0,1,2.467-2.454h2.467a2.461,2.461,0,0,1,2.468,2.454V284.859a2.461,2.461,0,0,1-2.468,2.454h-2.467a2.46,2.46,0,0,1-2.467-2.454Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M270.709,181.81a2.46,2.46,0,0,1,2.467-2.454h2.467a2.461,2.461,0,0,1,2.468,2.454V284.859a2.461,2.461,0,0,1-2.468,2.454h-2.467a2.46,2.46,0,0,1-2.467-2.454Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon);
export default __webpack_public_path__ + "static/media/favicon.ad97c6983c803c61ae515f370b4efc38.svg";
export { ForwardRef as ReactComponent };